import { LRUCache } from "lru-cache";
import LayerGroup from "ol/layer/Group";
import { isMobileDevice } from "../util/deviceDetectionUtil";
import { isWebGLSupported } from "../util/webGLUtils";
import GlacialTileLayer from "./GlacialTileLayer";
export default class GlacialTileLayerGroup {
    layerGroup = new LayerGroup();
    // Store only 5 layers to save memory. Older mobile devices crash if
    // too many layers are loaded.
    layers = new LRUCache({
        max: isMobileDevice() ? 5 : 10,
        dispose: (layer) => {
            this.layerGroup.getLayers().remove(layer.getLayer());
        },
    });
    onMapRenderCompleteOnce;
    settings;
    constructor({ settings, onMapRenderCompleteOnce, }) {
        this.settings = settings;
        this.onMapRenderCompleteOnce = onMapRenderCompleteOnce;
        this.onYearChange();
        this.settings.addEventListerner({
            onYearChange: () => this.onYearChange(),
            onLayerOpacityChange: () => this.onLayerOpacityChange(),
        });
    }
    getLayerGroup() {
        return this.layerGroup;
    }
    onYearChange = () => {
        if (!isWebGLSupported()) {
            return;
        }
        const nextYear = this.settings.getYear();
        // Next year is not supported year for ice. Hide layer and return.
        if (!this.settings.getSupportedIceYears().includes(nextYear)) {
            this.hideAllLayers();
            return;
        }
        const nextLayer = this.layers.get(nextYear);
        if (!nextLayer) {
            const newLayer = new GlacialTileLayer(nextYear, this.settings);
            this.layers.set(nextYear, newLayer);
            newLayer.getSource().once("tileloadend", () => {
                this.onMapRenderCompleteOnce?.(() => {
                    this.setLayerVisible(newLayer);
                });
            });
            this.layerGroup.getLayers().push(newLayer.getLayer());
        }
        else {
            this.setLayerVisible(nextLayer);
        }
    };
    setLayerVisible = (nextLayer) => {
        nextLayer.getLayer().setVisible(true);
        this.layers.forEach((prevLayer) => {
            if (prevLayer.getYear() !== nextLayer.getYear() &&
                prevLayer.getLayer().isVisible()) {
                prevLayer.getLayer().setVisible(false);
            }
        });
    };
    hideAllLayers = () => {
        this.layers.forEach((layer) => {
            layer.getLayer().setVisible(false);
        });
    };
    onLayerOpacityChange() {
        this.layers.forEach((layer) => {
            layer.onLayerOpacityChange(this.settings);
        });
    }
}
